import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { IRegion } from 'src/Interfaces/WellInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { IEBPExpenseType, IProduct } from '../../../../Interfaces/TestInterface';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';


interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminProducts extends React.Component {
    public props: any;
    public adminStore: AdminStore;
    public productsDisposer: any; 
    public products: IProduct[] = [];
    public productList: IList;
    public dataService: any = new DataService();
    public expenseTypesDisposer: any;
    private UserStore: UserStore;
    private TenantStore: TenantStore;

    private tableHeaders: any[] = [
        { content: 'Product', 'class': 'align-left' },
        { content: 'Primary Category', 'class': 'align-left' },
        { content: 'Taxable', 'class': 'align-left'},
        { content: 'Unit Size', 'class': 'align-left' },
        { content: 'Unit of Measure', 'class': 'align-left' },
        { content: 'Specific Gravity', 'class': 'align-left' },
        { content: 'Weight', 'class': 'align-left' },
        { content: 'Cost', 'class': 'align-left' },
        { content: 'Retail Price', 'class': 'align-left' }
    ];

    private expenseTableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Type', 'class': 'align-left' },
        { content: 'Taxable', 'class': 'align-left' },
        { content: 'Cost', 'class': 'align-left' },
        { content: 'Price', 'class': 'align-left' },
    ];

    public state = {
        expenseTypes: [] as IEBPExpenseType[],
        formattedExpenseTypeData: undefined as unknown as IList,
        formattedProductsData: this.productList,
        products: this.products,
        regionData: this.productList,
        regions: [] as IRegion[],
        showDefault: false,
        showExpense: false,
        showRegion: true,
    };

    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
        this.adminStore = this.props.stores.AdminStore;
        this.TenantStore = this.props.stores.TenantStore;
    }

    public componentDidMount() {

        this.createDisposers();
        if (this.UserStore.hasPermission('Permissions.Admin.Inventory.Read')) {
            this.adminStore.getProducts();
            this.adminStore.getExpenseTypes();
        }

        if (this.UserStore.hasPermission('Permissions.Admin.Regions.Read')) {
            this.adminStore.getRegions()
                .then(regions => this.setState({regions}, () => this.formatRegionDataTable()));
        }
            // .catch(error => console.error(error))
            // .then(data => this.formatRegionDataTable());
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.productsDisposer = intercept(this.adminStore, 'products', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                products: data
            });

            this.formatDataTable();

            return change;
        });

        this.expenseTypesDisposer = intercept(this.adminStore, 'expenseTypes', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                expenseTypes: data
            });

            this.formatExpenseDataTable();

            return change;
        });
    }

    private toggleModal = (name: string) => () => {
        this.setState({[name]: !this.state[name]});
    }
    private toggleShowDefault = () => {
        this.setState({showDefault: !this.state.showDefault});
    }

    private toggleShowRegion = () => {
        this.setState({showRegion: !this.state.showRegion});
    }

    public clearDisposers() {
        this.productsDisposer();
        this.expenseTypesDisposer();
    }

    public rendername(product: IProduct) {
        return(
            <Link to={'/admin/products/' + product.id}>{product.name}</Link>
        );
    }

    public renderRegionName = (region: IRegion) => () => {
        return(
            <Link to={'/admin/regions/' + region.id}>{region.name}</Link>
        );
    }
    public formatDataTable() {
        let formattedData = [] as any[];
        if (this.state.formattedProductsData){
            formattedData = this.state.formattedProductsData.rows;
            formattedData.splice(0);
        }
        this.state.products.map((product: IProduct, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: this.rendername.bind(this, product),
                    sortItem: product.name,
                    type: 'render'
                },
                {
                    content: product.categorys && product.categorys[0] ? product.categorys[0].name : ''
                },
                {
                    content: product.isTaxable ? 'Yes' : 'No',
                },
                {
                    content: product.size
                },
                {
                    content: product.unit
                },
                {
                    content: product.specificGravity
                },
                {
                    content: product.weight
                },
                {
                    'class': 'align-left',
                    content: '$' + Number(product.cost).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                },
                {
                    'class': 'align-left',
                    content: '$' + Number(product.retailPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            formattedProductsData: {
                headers: this.tableHeaders,
                rows: formattedData
            }
        });
    }

    public renderExpenseTypeName(expenseType: IEBPExpenseType) {
        return(
            <Link to={'/admin/expenseTypes/' + expenseType.id}>{expenseType.name}</Link>
        );
    }

    public formatExpenseDataTable() {
        const formattedData: any[] = [];
        this.state.expenseTypes.map((expenseType: IEBPExpenseType, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: this.renderExpenseTypeName.bind(this, expenseType),
                    sortItem: expenseType.name,
                    type: 'render'
                },
                {
                    'class': 'align-left',
                    content: expenseType.isRental === true ? 'Rental' : 'Service'
                },
                {
                    content: expenseType.isTaxable ? 'Yes' : 'No',
                },
                {
                    'class': 'align-left',
                    content: '$' + Number(expenseType.cost).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                },
                {
                    'class': 'align-left',
                    content: '$' + Number(expenseType.retailPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            formattedExpenseTypeData: {
                headers: this.expenseTableHeaders,
                rows: formattedData
            }
        });
    }

    public formatRegionDataTable() {
        const rows: any[] = [];
        this.state.regions.forEach((region: IRegion, index:number) => {
            const row = [
                {
                    content: this.renderRegionName(region),
                    sortItem: region.name,
                    type: 'render',
                },
                {
                    content: region.state
                }
            ];
            rows.push(row);
        });

        const headers = [
            {
                content: "Region"
            },
            {
                content: "State"
            }
        ];

        this.setState({
            regionData: {headers, rows}
        });
    }

    public render() {
        const hasInventoryPerm = this.UserStore.hasPermission('Permissions.Admin.Inventory.Read');
        const hasRegionPerm = this.UserStore.hasPermission('Permissions.Admin.Regions.Read');
        return(
            <div>
                {
                    hasRegionPerm && 
                    <React.Fragment>
                        <Row className="header">
                            <Col>
                                <h4 onClick={this.toggleShowRegion}>
                                    <FontAwesomeIcon   
                                        icon="chevron-right"
                                        color={this.TenantStore.iconColor}
                                        rotation={ this.state.showRegion ?
                                            90 : 270
                                        }
                                        transform="shrink-2"
                                        style={{marginRight: '10px'}}
                                    />
                                Regions List</h4>
                            </Col>
                        </Row>
                        { this.state.showRegion && 
                        <React.Fragment>
                            <Row className="header">
                                <Col md="6">
                                    <h1>Regions</h1>
                                </Col>
                                <Col md="6">
                                    {
                                        this.UserStore.hasPermission('Permissions.Admin.Regions.Create') &&
                                        <Link to="/admin/regions/new">
                                            <Button color="primary" className="float-right">
                                                Add New Region
                                            </Button>
                                        </Link>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <DataTable list={this.state.regionData} />
                                </Col>
                            </Row>
                        </React.Fragment>
                        }
                    </React.Fragment>
                }
                {
                    hasInventoryPerm &&
                    <React.Fragment>
                        <Row className="header">
                            <Col>
                                <h4 onClick={this.toggleShowDefault}>
                                    <FontAwesomeIcon   
                                        icon="chevron-right"
                                        color={this.TenantStore.iconColor}
                                        rotation={ this.state.showDefault ?
                                            90 : 270
                                        }
                                        transform="shrink-2"
                                        style={{marginRight: '10px'}}
                                    />
                                Master Retail Product List</h4>
                            </Col>
                        </Row>
                        {
                        this.state.showDefault &&
                        <React.Fragment>
                            <Row className="header">
                                <Col md="12">
                                    { 
                                        this.UserStore.hasPermission('Permissions.Admin.Inventory.Create') &&
                                        <Link to="/admin/products/new">
                                            <Button color="primary" className="float-right">
                                                Add New Product
                                            </Button>
                                        </Link>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12">
                                    <DataTable list={this.state.formattedProductsData} />
                                </Col>
                            </Row>
                        </React.Fragment>
                        }
                        <Row className="header">
                            <Col>
                                <h4 onClick={this.toggleModal('showExpense')}>
                                    <FontAwesomeIcon   
                                        icon="chevron-right"
                                        color={this.TenantStore.iconColor}
                                        rotation={ this.state.showExpense ?
                                            90 : 270
                                        }
                                        transform="shrink-2"
                                        style={{marginRight: '10px'}}
                                    />
                                Master Retail EBP List</h4>
                            </Col>
                        </Row>
                        {
                            this.state.showExpense &&
                            <React.Fragment>
                                <Row className="header">
                                    <Col md="12">
                                        {
                                            this.UserStore.hasPermission('Permissions.Admin.Inventory.Create') &&
                                            <Link to="/admin/expenseTypes/new">
                                                <Button color="primary" className="float-right">
                                                    Add New EBP Item
                                                </Button>
                                            </Link>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12">
                                        <DataTable list={this.state.formattedExpenseTypeData} />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }

            </div>
        );
    }

}

export default AdminProducts;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Products/AdminProducts.tsx